// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__37MAX","image":"App_image__3IlON","github":"App_github__1V50k"};